<template>
	<div>
		<b-modal ref="generateSettlement" hide-footer :title="generateSettlementModalTitle">
			<div class="row">
				<div class="form-group col col-md-12">
					<label for="_paymentDate" class="control-label">Data płatności</label>
					<el-date-picker
							id="_paymentDate"
							v-model="settlementDate"
							type="date"
							placeholder="">
					</el-date-picker>
				</div>
			</div>
			<b-row>
				<b-col>
					<b-button class="mt-3" variant="primary" block @click="hideGenerateSettlement()"><span>Anuluj</span>
						<svg-icon name="back"/>
					</b-button>
				</b-col>
				<b-col>
					<b-button class="mt-3" variant="default" block @click="handleGenerateSettlement()"><span>Zapisz</span>
						<svg-icon name="tick"/>
					</b-button>
				</b-col>
			</b-row>
		</b-modal>

		<div v-if="generatedShowMessage" class="alert alert-success">Rozliczenie zostało wygenerowane</div>
		<div v-if="settlementError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ settlementError }}
		</div>
		<alert-loading v-if="loading"></alert-loading>
		<b-row v-if="!loading && retrieved.currency.foreign == false">
			<b-col>
				<my-button v-if="!isSettlementAlreadyGenerated" text="Generuj rozliczenie" icon="summary" :action="generateSettlement"/>
				<my-button v-if="isSettlementAlreadyGenerated" text="Generuj ponownie" icon="summary" variant="primary" :action="generateSettlement"/>
				<my-button v-if="isSettlementAlreadyGenerated " class="poll-right" text="Pobierz wszystko" icon="summary" variant="primary" :action="downloadAllFile"/>
			</b-col>
		</b-row>

		<b-row v-if="!loading && retrieved.currency.foreign">
			<b-col>
				<my-button v-if="!isSettlementAlreadyGenerated" text="Generuj rozliczenie wstępne" icon="summary" :action="generateInitialSettlement"/>
				<my-button v-if="isSettlementAlreadyGenerated"  text="Generuj ponownie rozliczenie wstępne" icon="summary" variant="primary" :action="generateInitialSettlement"/>
				<my-button v-if="!isFinalSettlementAlreadyGenerated" text="Generuj rozliczenie całkowite" icon="summary" :action="generateFinalSettlement"/>
				<my-button v-if="isFinalSettlementAlreadyGenerated" text="Generuj ponownie rozliczenie całkowite" icon="summary" variant="primary" :action="generateFinalSettlement"/>
				<my-button v-if="isFinalSettlementAlreadyGenerated || isSettlementAlreadyGenerated " class="poll-right" text="Pobierz wszystko" icon="summary" variant="primary" :action="downloadAllFile"/>
			</b-col>
		</b-row>

		<div v-if="!loading" class="table-responsive">
			<table class="table table-striped table-bordered table-hover table-clickable table-search">
				<thead>
				<tr>
					<th>Nazwa</th>
					<th>Data przelewu</th>
					<th>Typ dokumentu</th>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in settlementListItems" >
					<td class="td-no_link">{{ item.name }}</td>
					<td class="td-no_link">{{ item.paymentDate|date }}</td>
					<td class="td-no_link">{{ item.type | translate }}</td>
					<td>
						<a href="#" class="btn btn-icon" v-b-tooltip.hover.bottom title="Pobierz" @click.prevent="downloadFile(item.id)">
							<svg-icon name="download"/>
						</a>
						<a href="#" class="btn btn-icon" v-b-tooltip.hover.bottom title="Podgląd" @click.prevent="previewFile(item.id)">
							<svg-icon name="preview"/>
						</a>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import http from './../../utils/http'
  import moment from 'moment'

  export default {
    mounted () {
      this.getSettlementList(this.retrieved.id);
    },
    data: function () {
      return {
        settlementDate: new Date,
		settlementType: 'settlement',
        item: {},
        errors: {},
        generatedShowMessage: false
      }
    },
    methods: {
      downloadAllFile(){
        http.download('/download/agreement/all-settlement/' + this.retrieved.id + '?');
      },
      downloadFile(documentId){
        http.download('/download/agreement/settlement/' + documentId + '?');
      },
      previewFile(documentId){
        http.preview('/download/preview/agreement/settlement/' + documentId + '?');
      },
      handleGenerateSettlement(){
        this.$refs.generateSettlement.hide()
        this.generate({agreement: this.retrieved.id, date: moment(this.settlementDate).format('YYYY-MM-DD'), type: this.settlementType})
	  },
      hideGenerateSettlement(){
        this.$refs.generateSettlement.hide()
	  },
      generateSettlement () {
        this.settlementType = 'settlement'
        this.$refs.generateSettlement.show()
      },
      generateInitialSettlement(){
        this.settlementType = 'initial_settlement'
        this.$refs.generateSettlement.show()
	  },
      generateFinalSettlement(){
        this.settlementType = 'final_settlement'
        this.$refs.generateSettlement.show()
      },
      ...mapActions({
        generate: 'agreement/settlement/generate',
        getSettlementList: 'agreement/settlementList/getItems'
      })
    },
    computed: {
      loading () {
        return this.retrieveLoading || this.settlementLoading || this.settlementListLoading
      },
      isSettlementAlreadyGenerated () {
        if (this.retrieved && this.retrieved.step.indexOf('settlement-generated') > -1) {
          return true
        }
        return false
      },
      isFinalSettlementAlreadyGenerated () {
        if (this.retrieved && this.retrieved.step.indexOf('final-settlement-generated') > -1) {
          return true
        }
        return false
      },
      generateSettlementModalTitle(){
        if(this.settlementType == 'settlement'){
          return 'Generuj rozliczenie'
		}
        if(this.settlementType == 'initial_settlement'){
          return 'Generuj rozliczenie wstępne'
        }
        if(this.settlementType == 'final_settlement'){
          return 'Generuj rozliczenie końcowe'
        }
        return ''
	  },
      ...mapGetters({
        retrieveLoading: 'agreement/update/retrieveLoading',
        settlementLoading: 'agreement/settlement/loading',
        settlementListLoading: 'agreement/settlementList/loading',
        settlementListItems: 'agreement/settlementList/items',
        settlementError: 'agreement/settlement/error',
        settlementGenerated: 'agreement/settlement/generated',
        retrieved: 'agreement/update/retrieved',
      })
    },
    watch: {
      'settlementGenerated': function (data) {
        if (data != null) {
          this.generatedShowMessage = true
          setTimeout(() => {
            this.generatedShowMessage = false
          }, 5000)
          this.getSettlementList(this.retrieved.id)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UpdateSettlement.vue?df85de3c